class apiHelper{
	constructor() {
    }

    init() {
        if (document.getElementById('grp')) {
            this.statistics();
        }
    }

    formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    
    // Each statistics module has the same four stats that it gets 
    statistics() {
        var industry = $('#emsi').attr('data-industry');

       $.when(
            $.post('/wp-json/emsi/grp', { 'file' : 'grp'}),
            $.post('/wp-json/emsi/growth-locations')
        ).done((grp, growthLocations) => {

            console.log(grp);
            // Get the index of the industry in the data
            var industries = grp[0].data.data[2].rows;
            var industryIndex = industries.indexOf(industry);

            // GRP formatting
            var GRP = grp[0].data.data[3].rows[industryIndex];
            GRP = GRP / 1000000000;
            GRP = GRP.toFixed(2);
            var GRPBillions = '$' + GRP + 'B';
            $('#grp').html(GRPBillions);

            // Get the index of the industry in the growth-locations datas
            var industries = grp[0].data.data[2].rows;
            var industryIndex = industries.indexOf(industry);

            console.log(growthLocations);
            // Location formatting
            var locations = growthLocations[0].data.data[5].rows[industryIndex];
            locations = locations.toFixed(0);
            locations = this.formatNumber(locations);
            $('#locations').html(locations);


            // Job Growth formatting
            var jobs2014 = growthLocations[0].data.data[4].rows[industryIndex];
            var jobs2019 = growthLocations[0].data.data[3].rows[industryIndex];

            var newjobs = jobs2019 - jobs2014;

            var growth = (newjobs / jobs2014) * 100;
            growth = growth.toFixed(1) + '%';
            $('#growth').html(growth);

            // Industry Workers
            var workers = jobs2019.toFixed(0);
            workers = this.formatNumber(workers);
            $('#workers').html(workers);


            if (window.innerWidth > 769) {

                var letters = document.querySelectorAll('.letters');
                console.log(letters);
                for (var i = 0; i < letters.length; i++) {
                    var item = letters[i];
                    item.innerHTML = item.textContent.replace(/\S/g, "<span class='letter' data-aos='fade-up' data-aos-duration='800'>$&</span>");
                    var individualLetters = item.querySelectorAll('.letter');
                    for (var j = 0; j < individualLetters.length; j++) {
                        individualLetters[j].dataset.aosDelay = j * 100;
                    }
                }
            }

        }).catch(function (error) {
            // if there's an error, log it
            console.log(error);
        });

        
    }


	
}
window.app.add('api', new apiHelper());